import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Flex } from '@stackhouse/styled-elements'

import Form from '../ResponsiveForm'

export default class FiltersBox extends PureComponent {

    constructor(props) {
        super(props)
        this.formRef = React.createRef()

        const { filters = [], openSections = [] } = props

        const { id, value: defaultFilter = null } = filters.find(filter => filter.default === 'Y') || {}
        const { query = '', barcodeSearch = false, fields: filter = {} } = JSON.parse(defaultFilter) || {}

        const filtersOptions = filters.map(filter => ({ ...filter, label: filter.title, value: filter.id }))
        this.state = {
            filters: filtersOptions,
            openSections,
            query,
            filter,
            barcodeSearch,
            currentFilter: id,
            advancedFilters: !!defaultFilter,
            shouldUpdateFilterValue: true,
        }
    }

    static propTypes = {
        fields: PropTypes.array,
        filters: PropTypes.array,
        openSections: PropTypes.array
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.filters !== this.props.filters) {
            const { filters = [], openSections = [] } = this.props
            const filtersOptions = filters.map(filter => ({ ...filter, label: filter.title, value: filter.id }))

            if (this.state.shouldUpdateFilterValue) {
                const { id, value: defaultFilter = null } = filters.find(filter => filter.default === 'Y') || {}
                const { query = '', barcodeSearch = false, fields: filter = {} } = JSON.parse(defaultFilter) || {}

                return this.setState({ filters: filtersOptions, openSections, query, barcodeSearch, filter, currentFilter: id, advancedFilters: !!defaultFilter }, () => {
                    return this.formRef.current.reloadData(this.state.filter)
                })
            }
            else {
                return this.setState({ filters: filtersOptions, openSections, shouldUpdateFilterValue: true })
            }
        }
    }

    getFilter = () => {
        return { query: this.state.query, filter: this.formRef.current.getValue(), barcodeSearch: this.state.barcodeSearch }
    }

    onChangeFilter = (filter) => {
        return this.setState({ filter, currentFilter: null })
    }

    render() {
        const { fields } = this.props
        const { filter, openSections } = this.state

        return (
            <Flex column>
                <Flex column pb={[10, 0]}>
                    <Form ref={this.formRef} fields={fields} value={filter} onChange={this.onChangeFilter} openSections={openSections} />
                </Flex>
            </Flex>
        )
    }
}
